import { X } from 'lucide-react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { cn } from '@maxus/website/utils'

import { Button } from '..'

type MaxusConfirmModalProps = {
  cancelLabel?: string
  children?: ReactNode
  className?: string
  confirmLabel?: string
  description?: string
  onCancel: () => void
  onConfirm: () => void
  showClose?: boolean
  title: string
}

// 打开方传入的确认弹窗内容：文案与确认动作均由调用处提供，弹窗本身只负责渲染
type ConfirmModalConfig = {
  cancelLabel?: string
  className?: string
  confirmLabel?: string
  description?: string
  onCancel?: () => void
  onConfirm: () => void
  title: string
}

const MaxusConfirmModal = ({
  cancelLabel,
  children,
  className,
  confirmLabel,
  description,
  onCancel,
  onConfirm,
  showClose = false,
  title,
}: MaxusConfirmModalProps) => {
  const { t } = useTranslation()
  return (
    <div className="fixed inset-0 z-[60] grid place-items-center bg-[#000000]/60" data-slot="maxus-modal-backdrop">
      <section
        data-slot="maxus-confirm-modal"
        className={cn(
          'flex w-[316px] flex-col rounded-lg border border-border-subtle bg-surface-card p-4 shadow-2xl shadow-black/50',
          className,
        )}
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-base font-semibold text-text-primary">{title}</h2>
            {description && <p className="mt-4 max-w-[282px] text-xs leading-5 text-text-tertiary">{description}</p>}
          </div>
          {showClose && (
            <Button aria-label={t('Close')} onClick={onCancel} size="icon-xs" variant="ghost">
              <X className="size-4" />
            </Button>
          )}
        </div>
        {children}
        <div className="mt-auto flex justify-end gap-3">
          <Button className="h-7 px-4" onClick={onCancel} size="sm" variant="secondary">
            {cancelLabel ?? t('Cancel')}
          </Button>
          <Button className="h-7 px-4" onClick={onConfirm} size="sm">
            {confirmLabel ?? t('Confirm')}
          </Button>
        </div>
      </section>
    </div>
  )
}

export { MaxusConfirmModal }
export type { ConfirmModalConfig, MaxusConfirmModalProps }
